document.addEventListener('DOMContentLoaded', function() {
  var metafield = document.querySelector('.metafield-multi_line_text_field');
  var originalPrices = {};
  var renderObserver = null;
  var rootObserver = null;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getButtons() {
    return Array.from(document.querySelectorAll('.bcpo-front-button-label'));
  }

  function getBcpoRoot() {
    return document.querySelector('#bcpo');
  }

  function setReorderPending() {
    var bcpoRoot = getBcpoRoot();
    if (bcpoRoot && !bcpoRoot.dataset.reorderReady) {
      bcpoRoot.dataset.reorderPending = 'true';
    }
  }

  function setReorderReady() {
    var bcpoRoot = getBcpoRoot();
    if (!bcpoRoot) {
      return;
    }

    delete bcpoRoot.dataset.reorderPending;
    bcpoRoot.dataset.reorderReady = 'true';
  }

  function getSectionLabels() {
    var bcpoRoot = getBcpoRoot();
    if (!bcpoRoot) {
      return [];
    }

    return Array.from(
      bcpoRoot.querySelectorAll('label, legend, .bcpo-label, .bcpo-title')
    ).filter(function(node) {
      var text = normalizeText(node.textContent);
      if (!text) {
        return false;
      }

      if (node.classList && node.classList.contains('bcpo-front-button-label')) {
        return false;
      }

      return (
        text.indexOf('size') !== -1 ||
        text.indexOf('dimension') !== -1 ||
        text.indexOf('color') !== -1 ||
        text.indexOf('colour') !== -1 ||
        text.indexOf('base') !== -1 ||
        text.indexOf('stone') !== -1
      );
    });
  }

  function findOptionGroupFromLabel(labelNode) {
    var bcpoRoot = getBcpoRoot();
    var current = labelNode;

    while (current && current !== bcpoRoot) {
      if (
        current.id.indexOf('bcpo-select-option-') === 0 ||
        current.classList.contains('bcpo-option') ||
        current.classList.contains('bcpo-group') ||
        current.classList.contains('bcpo-fieldset')
      ) {
        return current;
      }

      var childButtonCount = current.querySelectorAll('.bcpo-front-button-label').length;
      var childInputCount = current.querySelectorAll('input, select, textarea').length;

      if ((childButtonCount || childInputCount) && current !== labelNode) {
        return current;
      }

      current = current.parentElement;
    }

    return null;
  }

  function getOptionGroups() {
    return getSectionLabels()
      .map(function(labelNode) {
        return {
          label: normalizeText(labelNode.textContent),
          group: findOptionGroupFromLabel(labelNode)
        };
      })
      .filter(function(item, index, list) {
        return item.group && list.findIndex(function(entry) {
          return entry.group === item.group;
        }) === index;
      });
  }

  function isSizeLabel(label) {
    return label.indexOf('size') !== -1 || label.indexOf('dimension') !== -1;
  }

  function isVariantVisualLabel(label) {
    return (
      label.indexOf('color') !== -1 ||
      label.indexOf('colour') !== -1 ||
      label.indexOf('base') !== -1 ||
      label.indexOf('stone') !== -1
    );
  }

  function moveSizeGroupBelowVariants() {
    var groups = getOptionGroups();
    if (!groups.length) {
      return false;
    }

    var sizeEntry = groups.find(function(item) {
      return isSizeLabel(item.label);
    });

    if (!sizeEntry) {
      return false;
    }

    var variantEntries = groups.filter(function(item) {
      return item.group !== sizeEntry.group && isVariantVisualLabel(item.label);
    });

    if (!variantEntries.length) {
      return false;
    }

    var anchorGroup = variantEntries[variantEntries.length - 1].group;
    if (
      anchorGroup &&
      sizeEntry.group &&
      anchorGroup.nextElementSibling !== sizeEntry.group
    ) {
      anchorGroup.parentNode.insertBefore(sizeEntry.group, anchorGroup.nextElementSibling);
    }

    setReorderReady();
    return true;
  }

  function watchOptionRendering() {
    var bcpoRoot = getBcpoRoot();
    if (!bcpoRoot) {
      return;
    }

    setReorderPending();
    moveSizeGroupBelowVariants();

    if (renderObserver) {
      renderObserver.disconnect();
    }

    renderObserver = new MutationObserver(function() {
      setReorderPending();
      if (moveSizeGroupBelowVariants()) {
        setReorderReady();
      }
    });

    renderObserver.observe(bcpoRoot, {
      childList: true,
      subtree: true
    });
  }

  function waitForOptionsApp() {
    var attempts = 0;

    function tryInit() {
      attempts += 1;

      if (getBcpoRoot()) {
        setReorderPending();
      }

      if (getBcpoRoot() && getOptionGroups().length) {
        watchOptionRendering();
        return;
      }

      if (attempts < 40) {
        setTimeout(tryInit, 150);
      }
    }

    tryInit();

    if (!rootObserver) {
      rootObserver = new MutationObserver(function() {
        if (getBcpoRoot()) {
          setReorderPending();
        }

        if (getBcpoRoot() && getOptionGroups().length) {
          watchOptionRendering();
        }
      });

      rootObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  function updatePrices() {
    var priceElements = document.querySelectorAll('.product__price .money, .price .money, [data-price]');
    var priceElement = null;
    var buttons = getButtons();

    for (var i = 0; i < priceElements.length; i++) {
      var el = priceElements[i];
      if (el.offsetParent !== null && el.textContent.trim() !== '') {
        priceElement = el;
        break;
      }
    }

    if (!priceElement) {
      return;
    }

    var currentPrice = priceElement.textContent.trim();
    var selectedSizeButton = document.querySelector('.bcpo-front-button-label.selected, input[type="radio"]:checked + .bcpo-front-button-label');
    var selectedSizeName = null;

    if (selectedSizeButton) {
      selectedSizeName = selectedSizeButton.textContent.split(':')[0].trim();
    }

    buttons.forEach(function(button) {
      var buttonPriceElement = button.querySelector('.vo-price-display');
      var textSpan = button.querySelector('span');
      var sizeName = textSpan ? textSpan.textContent.split(':')[0].trim() : '';

      if (!buttonPriceElement) {
        return;
      }

      if (selectedSizeName && selectedSizeName === sizeName) {
        buttonPriceElement.textContent = currentPrice;
      } else {
        buttonPriceElement.textContent = originalPrices[sizeName] || buttonPriceElement.textContent;
      }
    });
  }

  function initPriceLabels() {
    if (!(metafield && getButtons().length > 0)) {
      return;
    }

    var sizeData = metafield.textContent.trim();

    getButtons().forEach(function(button) {
      var fullText = button.textContent.trim();
      var sizeName = fullText.split('$')[0].trim();

      if (sizeName === 'Small' || sizeName === 'Medium' || sizeName === 'Large') {
        var pattern = sizeName + ':\\s*(.*?)(?=\\s+(?:Small|Medium|Large)|$)';
        var regex = new RegExp(pattern, 'i');
        var match = sizeData.match(regex);

        if (match && match[1]) {
          var dimensions = match[1].trim();
          var originalPrice = '$' + fullText.split('$')[1];
          originalPrices[sizeName] = originalPrice;
          button.innerHTML = '<span style="display: flex; justify-content: space-between; width: 100%;"><span>' + sizeName + ': ' + dimensions + '</span><span class="vo-price-display money" data-product-price>' + originalPrice + '</span></span>';
        }
      }
    });

    document.addEventListener('change', function(e) {
      if (e.target.type === 'radio' || e.target.tagName === 'SELECT') {
        setTimeout(updatePrices, 300);
        setTimeout(moveSizeGroupBelowVariants, 50);
      }
    });

    setTimeout(updatePrices, 600);
  }

  waitForOptionsApp();
  initPriceLabels();
});
